export default __webpack_public_path__ + "static/media/femp_logo.13424a24.jpg";